import "pixi.js/unsafe-eval";
import { createRoot } from "react-dom/client";
import { createClientKernel } from "./Kernel/ClientKernel.ts";
import "./styles/fonts.css";
import { ClientContainerWrapper } from "./ClientContainerWrapper.tsx";
import { loadGeneratedAssetManifest } from "./Components/Drawable/generatedAssetManifest.ts";
import { installClientErrorReporter } from "./ClientErrorReporter.ts";
import { DESIGN_ASSET_SLOTS } from "./Domain/DesignAssetSlots.ts";

installClientErrorReporter();
for (const slot of DESIGN_ASSET_SLOTS) {
	document.documentElement.style.setProperty(`--design-${slot.id}`, `url("${slot.path}")`);
}

const container = document.getElementById("app");
if (!container) {
	throw new Error("Failed to find app container");
}

const clientKernel = createClientKernel();
const { logger } = clientKernel;

logger.box("Starting app");

const root = createRoot(container);
void (async () => {
	// Card URLs are resolved during render, so load their size variants first.
	await loadGeneratedAssetManifest();
	root.render(<ClientContainerWrapper kernelResult={clientKernel} />);
	if (import.meta.env.PROD && __OFFLINE_CACHE_ENABLED__) {
		void import("./Offline/registerOfflineCache.ts").then(({ registerOfflineCache }) => {
			void registerOfflineCache();
		});
	}
	logger.info("App started");
})();
